/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".seine-maritime-color-primary[_ngcontent-%COMP%]{background-color:#004158!important;color:#fff}.fidinam-color-primary[_ngcontent-%COMP%]{background-color:#d2163e!important;color:#fff}.li-color[_ngcontent-%COMP%]{background:#5f2454!important;color:#fff}.li-seine-maritime-color[_ngcontent-%COMP%]{background:#00798d!important;color:#fff}.li-fidinam-color[_ngcontent-%COMP%]{background:#dc2f34!important;color:#fff}"];
export { styles as styles };
